import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class AddDressCodePictureErrorAction implements Action {
  public static readonly type = 'AddDressCodePictureErrorAction';

  constructor(public error: BijbError) {
  }

  public type = AddDressCodePictureErrorAction.type;
}
